export default __webpack_public_path__ + "static/media/pic-1.5632a661.png";